import {AvisInitialTypeLight} from './AvisInitialTypeLight';
import { TypeFNSSimpleDescMarche2 } from './TypeFNSSimpleDescMarche2';
export class Rectificatif {

	public avisInitial: AvisInitialTypeLight;

	public natureMarche: TypeFNSSimpleDescMarche2;

	public infosRectif: String[];

	constructor() {
		this.avisInitial = new AvisInitialTypeLight();
		this.natureMarche = new TypeFNSSimpleDescMarche2();
		this.infosRectif = [];

	}
}
